import { styled } from '@mui/material/styles';

import { Button, type ButtonProps } from '../../../Button/Button';

const StyledDataGridHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px',
  backgroundColor: '#fff',
  borderRadius: '8px',
  marginBottom: '16px',
}));

const DataGridHeaderLabel = styled('div')(({ theme }) => ({
  fontSize: '24px',
  fontWeight: '400',
  lineHeight: 1.5,
  color: 'rgba(0, 0, 0, 0.87)',
}));

const DataGridHeaderActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  maxWidth: '200px',

  '&.MuiButtonBase-root': {
    marginLeft: '8px',
  },
}));

export type DataGridHeaderProps = {
  id: string;
  headerLabel: string;
  actionButtons?: ButtonProps[];
};

// DataGridHeader component
export const DataGridHeader = ({ id, headerLabel, actionButtons }: DataGridHeaderProps) => {
  return (
    <StyledDataGridHeader data-testid={`dataGridHeader-${id}`}>
      <DataGridHeaderLabel>{headerLabel}</DataGridHeaderLabel>
      <DataGridHeaderActions>
        {actionButtons?.map((button) => (
          <Button key={button.id} {...button} />
        ))}
      </DataGridHeaderActions>
    </StyledDataGridHeader>
  );
};
